import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="text-xl font-bold font-heading tracking-tight text-background-50 hover:text-accent-300 transition-colors">
              acbuyspreadsheet<span className="text-accent-500">.</span>
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-xs">
              The smarter way to track, organize, and optimize your online purchasing. Structured spreadsheet buying system for faster, more efficient shopping.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors">Home</Link>
              <Link to="/article/what-is-acbuyspreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors">What is ACbuyspreadsheet</Link>
            </div>
          </div>

          {/* Top Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Top Categories</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Shoes</a>
              <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Hoodies/Sweaters</a>
              <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">T-Shirts</a>
              <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Jackets</a>
              <a href="https://kaspreadsheet.com/category-920-Accessories.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Accessories</a>
            </div>
          </div>

          {/* Main Site */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Main Store</h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Visit Kaspreadsheet</a>
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors">Shop All Categories</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-700/30">
        <div className="mx-auto flex flex-col sm:flex-row items-center justify-between px-4 md:px-6 py-5 gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} acbuyspreadsheet.courses. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-background-200 transition-colors">Privacy Policy</a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-background-200 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}